export default {
  'password': '请输入密码',
  'passwordError': '密码为8-20位，仅支持大小写字母、数字和符号3种及以上的组合',
  'passwordAgain': '请再次输入密码',
  'passwordNotSame': '两次输入密码不一致',
  'requiredVerifyCode': '请输入验证码',
  'verifyCode': '验证码错误'
}
